// extracted by mini-css-extract-plugin
module.exports = {"errorTitle":"ChartStatus_errorTitle__2UDlx","table":"ChartStatus_table__10uBi"};